import React from "react";
import { SidebarProvider, Sidebar } from "@/components/ui/sidebar";
import PartnerSidebarNav from "./PartnerSidebarNav";
import PartnerHeader from "./PartnerHeader";

interface PartnerLayoutProps {
  children: React.ReactNode;
}

const PartnerLayout: React.FC<PartnerLayoutProps> = ({ children }) => {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-gray-50">
        <Sidebar className="!border-none bg-[#0e7cb4] border-r border-blue-600">
          <PartnerSidebarNav />
        </Sidebar>

        <div className="flex-1 flex flex-col overflow-hidden">
          <PartnerHeader />

          <main className="flex-1 overflow-auto p-6 bg-gray-50">
            {children}
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default PartnerLayout;
